import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { AbortFlowException2zdgh4w7z3hep as AbortFlowException } from './internal/FlowExceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { checkOwnershipoyid8o0pxxr7 as checkOwnership } from './internal/FlowExceptions.common.mjs';
import { ensureActive2yo7199srjlgl as ensureActive } from '../Job.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function takeWhile(_this__u8e3s4, predicate) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (takeWhile$$inlined$unsafeFlow$1())(_this__u8e3s4, predicate);
}
function *_generator_emit__qph46j($this, value, $completion) {
  var tmp;
  var tmp_0 = $this.n1h_1(value, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    var tmp_1 = $this.o1h_1.s1d(value, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = true;
  } else {
    tmp = false;
  }
  if (!tmp) {
    throw AbortFlowException().p1h($this);
  }
  return Unit_instance;
}
function *_generator_collect__dlomyy($this, collector, $completion) {
  // Inline function 'kotlinx.coroutines.flow.collectWhile' call
  var this_0 = $this.q1h_1;
  var collector_0 = new (takeWhile$$inlined$unsafeFlow$1$collect$2())($this.r1h_1, collector);
  try {
    var tmp = this_0.b1d(collector_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof AbortFlowException()) {
      var e = $p;
      checkOwnership(e, collector_0);
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp$ret$0 = $completion.rc();
      ensureActive(tmp$ret$0);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
var takeWhile$$inlined$unsafeFlow$1$collect$2Class;
function takeWhile$$inlined$unsafeFlow$1$collect$2() {
  if (takeWhile$$inlined$unsafeFlow$1$collect$2Class === VOID) {
    class $ {
      constructor($predicate, $$this$flow) {
        this.n1h_1 = $predicate;
        this.o1h_1 = $$this$flow;
      }
      b1h(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_emit__qph46j.bind(VOID, this, value), $completion);
      }
      s1d(value, $completion) {
        return this.b1h((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [FlowCollector()], [1]);
    takeWhile$$inlined$unsafeFlow$1$collect$2Class = $;
  }
  return takeWhile$$inlined$unsafeFlow$1$collect$2Class;
}
var takeWhile$$inlined$unsafeFlow$1Class;
function takeWhile$$inlined$unsafeFlow$1() {
  if (takeWhile$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($this_takeWhile, $predicate) {
        this.q1h_1 = $this_takeWhile;
        this.r1h_1 = $predicate;
      }
      t1d(collector, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_collect__dlomyy.bind(VOID, this, collector), $completion);
      }
      b1d(collector, $completion) {
        return this.t1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    takeWhile$$inlined$unsafeFlow$1Class = $;
  }
  return takeWhile$$inlined$unsafeFlow$1Class;
}
//region block: exports
export {
  takeWhile as takeWhile2lajz05xm93j8,
};
//endregion

//# sourceMappingURL=Limit.mjs.map
